/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-undef */
/* eslint-disable no-script-url */
import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import cn from 'classnames';
import { axios, endpoints, baseUrl } from 'Api';
import { AppContext, AuthContext } from 'Context';
import { Pathname } from 'Routes';
import { markSectionExplored, EXPLORED_SECTION } from 'Utils/onboardingChecklist';
import { isFloatingSidebarRoute } from 'Components/FloatingSidebar';
import { normalizeBg } from 'hooks/useProfileBg';
import { isNewUIEnabled, useNewUI } from 'hooks/useNewUI';
import { beginUiSwitch, settleDesignAfterLogout } from 'Utils/uiSwitchOverlay';
import { showProjectorSwitchOverlay, hideProjectorSwitchOverlay } from 'Utils/projectorSwitchOverlay';
import { subscribeCondense } from 'Utils/scrollCondense';
import { getHeaderName } from 'Utils/utils';
import { revokeCurrentDevice } from 'Utils/deviceSession';
import { ClapUploadIcon } from 'Components/UploadDropdown/ClapUploadIcon';
import { ReactComponent as AddIcon } from 'Assets/add-circle.svg';
import { ReactComponent as MenuIcon } from 'Assets/menu.svg';
import { ReactComponent as VideoUploadIcon } from 'Assets/video-upload.svg';
import { ReactComponent as ProfileIcon } from 'Assets/profile.svg';
import { ReactComponent as PersonIcon } from 'Assets/person-profile.svg';
import { ReactComponent as HomeIcon } from 'Assets/home-header.svg';
import { ReactComponent as SearchIcon } from 'Assets/search.svg';
import { ReactComponent as WatchlistIcon } from 'Assets/watchlistIcon.svg';
import AlterImage from 'Assets/alter-image.png';
import Spinner from 'Components/Spinner';
import { toast } from 'react-toastify';
import ArrowBackIos from 'Assets/backArrowIcon.svg';
import { isFreeUploadBlocked, PLANS, MAX_FREE_SIZE_GB } from 'Commons';
import useSWR from 'swr';
import ReactNotification, { store } from 'react-notifications-component';
import DehazeIcon from '@mui/icons-material/Dehaze';
import NotificationSound from 'Components/NotificationSound';
import { useSelector } from 'react-redux';
import { ref, update } from 'firebase/database';
import { saveUploadInfo, clearAllDummys } from 'store/store';
import Tooltip from '@mui/material/Tooltip';
import { Chip, Menu as MuiMenu, MenuItem } from '@mui/material';
import TrailpopUp from 'Components/VideoPopup/TrailpopUp';
import ProjectorCardNav from 'Components/reactbits/ProjectorCardNav';
import {
  AnimatedProjector, AnimatedLock, AnimatedLayoutGrid,
  AnimatedLayoutDashboard, AnimatedHelpCircle, AnimatedAlertTriangle,
  AnimatedTv, AnimatedGraduationCap, AnimatedBell, AnimatedUpload,
  AnimatedChevronLeft, AnimatedSearch, AnimatedBookmarkPlus,
  AnimatedCategory, AnimatedPlaylist, AnimatedAlbum,
} from 'Components/reactbits/AnimatedIcons';
import { motion, AnimatePresence } from 'framer-motion';
import { useAlerts, alertStore } from 'Utils/alertStore';
import uploadManager from '../../Utils/uploadManagerSecure';
import MessageComponent from '../../MessageComponent';
import Notifications from './components/Notifications';
import { Logo } from '../logo';
import { ShareScreen } from '../share-screen';
import { UploadModal } from '../upload-modal';
import { VideoUploadModal } from '../VideoUploadModal';
import { PhotoUploadModal } from '../PhotoUploadModal';
import { UploadDropdown } from '../UploadDropdown';
import styles from './index.module.css';
import 'react-notifications-component/dist/theme.css';
import { Drawer, Menu } from './components/CustomDesigns';
import ProgressBox from '../progressBox';
import DownloadProgressBox from '../downloadProgressBox';
import { HeaderIconButton, ProfileMenuProfileButton, ProfileDrawerProfileButton } from './components/HeaderIconButton';
import { InfoModal } from '../../Pages/private/dashboard/info-modal';
import CreateGroup from './components/createGroup';
import { VideoBanner } from './components/videoBanner';
import VideoUploadProgress from './components/VideoUploadProgress';
import BasicAccordion from './BasicAccordion';

export const Header = ({
  glassCompactHeaderBG,
  isProfileHeader,
  hideMenu,
  noHeader,
  noRegularHeader,
  onMenuClick,
  transparentCompactHeader,
  userName,
  userProfileLink,
  headerTheme,
  videoBanner,
  layoutData,
  slimV2
}) => {
  const { userConnections, userDetails, getUserConnections, langText, setViewerListUpdate, draftcontent,
    getAccessChecker, apiResponse, fetchData, autoSignIn, holdWhileDelete, uploaderLoader, setUploaderLoader, firebaseDatabase,
    setUploadContainer, uploadContainer, profileDetails, setProfileDetails, subscriptionDetails, showProgressBox, showDownloadBox,
    mangerFunctionData, setmangerFunctionData, messaged, setdataOfCategory,
    amICalled, setamICalled, uploadContainer2, setProfileLoader, projectorOwner,
    projectorImage, activeUploads, draftOfUpload, totalDraft, uploadQueue, setAppSnackbar, setVideoGroup, isCompleted,
    setisCompleted, trailModalVisible, setTrailPopUpModalVisible, setPopUpModalVisible,
    openNewUploadModal, setOpenNewUploadModal, openPhotoUploadModal, setOpenPhotoUploadModal, IsfreePlan, hasReachedStorageLimit,
    userAccessedData, managerPrivatePlanAccess, orderArrange } = useContext(AppContext);
  const { canSwitch: canSwitchUI } = useNewUI();
  const { removeToken, setUserSignInStatus, isInActiveUser, gettingSubscription, removeEmailVerified, setPreferredEmail, } = useContext(AuthContext);
  const headerText = langText?.header;
  const commonText = langText?.common;
  const uploadPosition = useSelector((state) => state.upload);
  const contentDashboard = langText?.contentDashboard;
  const [profileName, setProfileName] = useState(undefined);
  const [errorMsg, setErrorMsg] = useState(undefined);
  const location = useLocation();
  const navigate = useNavigate();
  const { profileID } = useParams();
  // Alert banner flips in over the pill; once dismissed it collapses to the
  // amber indicator on the pill (which flips the banner back in on click).
  const { showNavIcon: showNavAlert, showBanner: showAlertBanner, alerts: activeAlerts } = useAlerts();
  // The always-floating "pill" nav applies to standard app routes, but not to
  // the special headers (profile/video-banner/transparent) or the public/auth
  // landing pages, which have their own header treatments.
  // /profile now reuses the real slim-pill floating nav (same component as
  // Dashboard / Your Videos). The profile page carries friend context via
  // isProfileHeader + transparentCompactHeader, so allow the pill on /profile
  // despite those two flags (which still gate the old profileHeader elsewhere).
  // '/' is NOT excluded here. For a signed-in user the root path renders the
  // very same <Access /> page as /access (app.jsx: `path={Pathname.home}`), so
  // excluding it made a fresh load of localhost:3000 paint the old full-width
  // header, while /access — and every SPA navigation afterwards — got the
  // floating pill. Signed-out '/' externally redirects and never mounts this
  // header, and the auth/landing pages are already excluded below, so keying
  // the pill off the path's identity is what caused the mismatch, not the
  // route itself. See also the semi-oval below, which already treats '/' and
  // '/access' as the same screen.
  const isProfilePage = location.pathname.includes('/profile');
  const slimPill = slimV2
    && !videoBanner
    && !location.pathname.includes('/plan')
    && !location.pathname.includes('/newSign-in')
    && !location.pathname.includes('/getting-started')
    && (isProfilePage || (!isProfileHeader && !transparentCompactHeader));
  // The floating rail (FloatingSidebar) reserves 190px on the left on these
  // routes (see Components/page's .pageContent.withRail) — the pill nav needs
  // to start/end at the same edges as the content below it instead of
  // centering itself at 86% of the full viewport.
  const hasFloatingSidebar = isFloatingSidebarRoute(location.pathname);
  // Viewer-facing pages (a projector page + its category inner pages): the pill
  // sheds app-management icons (upload / notifications / TV — moved into the
  // dropdown) and surfaces viewer actions (search / watchlist) + a back arrow.
  const isViewerNav = isProfilePage
    || location.pathname.includes('/innerpage')
    || location.pathname.includes('/search')
    || location.pathname.includes('/watchlist');
  // "View My Projector" (/profile, no :profileID) is the owner's own page —
  // unlike a friend's projector (/profile/:id), Upload + Notifications stay.
  const isOwnProjectorView = isProfilePage && !profileID;
  // On the dashboard the pill's Upload control stays hidden until the user has
  // scrolled past the dashboard's own upload section (see scroll handler).
  const hideNavUploadUntilScroll = slimPill && location.pathname === Pathname.dashboard;
  const isFromGift = new URLSearchParams(location.search).get('fromGift') === 'true';
  const giftSuffix = isFromGift ? '?fromGift=true' : '';
  const afflitedRes = apiResponse?.data ? apiResponse?.data?.length : 0;
  const [dropDown, setDropDown] = useState(false);
  // Which nav pill is hovered — drives the animated icon (animate on the whole
  // button, not just the icon glyph).
  const [hoveredPill, setHoveredPill] = useState(null);
  // Content pages can ask the pill to slide away on scroll (scrollCondense bus).
  const [scrollCondensed, setScrollCondensed] = useState(false);
  useEffect(() => subscribeCondense(setScrollCondensed), []);
  const clearCache = () => {
    const cookies = document.cookie.split('; ');
    cookies.forEach((cookie) => {
      const [name] = cookie.split('=');
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    });
    // Clear local storage
    localStorage.removeItem('token');
    localStorage.removeItem('uploader_token');
    localStorage.removeItem('uploader_token_expiry');
    localStorage.removeItem('user_uuid');
    localStorage.removeItem('dismissedPaymentDialog');
    localStorage.removeItem('cardEXPDialog');
    // Clear session storage
    sessionStorage.clear();
    // Clear cache (for some browsers)
    if (window.caches) {
      window.caches.keys().then((cacheNames) => {
        cacheNames.forEach((cacheName) => {
          window.caches.delete(cacheName);
        });
      });
    }
  };
  const updateUploadPercentages = (draft_id, data) => {
    dispatch(saveUploadInfo({ [draft_id]: data }));
  };
  useEffect(() => {
    fetchData();
  }, []);
  const getToken = () => localStorage.getItem('token');
  const databaseRef = ref(firebaseDatabase, 'status_from_sns');
  const changeFieldFromFirebase = (draft_id, statusString) => {
    const dataToUpdate = {
      [draft_id]: {
        status: statusString,
      },
    };
    update(databaseRef, dataToUpdate);
  };
  const closeToast = (draft_id, message, type) => {
    toast.update(draft_id, { closeButton: false, render: message, type: type === 'success' ? toast.TYPE.SUCCESS : toast.TYPE.ERROR, autoClose: 3000 });
    setUploadContainer((prevUploadContainer) => prevUploadContainer.filter((id) => id !== draft_id));
    // setUploadContainer2((prevUploadContainer) => prevUploadContainer.filter((id) => id !== draft_id));
  };

  const updateDummy = (dummy, status) => {
    if (status === 1) {
      dispatch(saveDummy({ [dummy?.draft_id]: dummy }));
    } else {
      dispatch(removeDummy(dummy));
    }
  };
  const clearAllDummy = () => {
    dispatch(clearAllDummys());
  };
  const handleEncouter = (draft_id) => {
    const deletePromise = axios
      .post(`${baseUrl}/deleteDraftContent`, {
        token: getToken(),
        draft_id: [draft_id],
        content_id: [],
      })
      .then((response) => {
        changeFieldFromFirebase(draft_id, 'DELETED');
        updateDummy(draft_id, 0);
        updateUploadPercentages(draft_id, 'Cancelled');
        closeToast(draft_id, 'Upload has been canceled by user', 'error');
        return response;
      })
      .catch((error) => {
        updateDummy(draft_id, 0);
        // Nobody awaits this promise — it is fired from logout() — so
        // rethrowing here only produced an unhandled rejection (the red
        // "Uncaught runtime error" overlay in dev) on the way out.
        console.error('Failed to cancel draft on logout:', error);
      });
  };
  const uploadPercentages = useSelector((state) => state.upload);
  const logout = () => {
    // Leave the private route FIRST. Clearing the session while the router is
    // still on a signed-in path (e.g. /settings, where the layout switch drops
    // you) lets the signed-out route table paint that path for a frame — which
    // is how the privacy screen used to flash on the way out. The menu item's
    // <Link> targets the same page, so this is only about ordering.
    navigate(Pathname.authentication.newsignIn, { replace: true });
    const filteredKeys = Object.keys(uploadPercentages).filter(
      (key) => typeof uploadPercentages[key] === 'number'
        || uploadPercentages[key] === 'Starting Upload'
        || uploadPercentages[key] === 'Initializing'
    );
    if (filteredKeys?.length > 0) {
      filteredKeys.forEach((draft_id) => {
        handleEncouter(draft_id);
      });
    }
    // Best-effort: revoke this session server-side before the token is cleared.
    revokeCurrentDevice();
    clearCache();
    removeToken();
    setUserSignInStatus(false);
    removeEmailVerified();
    setPreferredEmail('');
    clearAllDummy();
    // Sign-in screen shows the backend's default design, not this user's pick.
    settleDesignAfterLogout();
  };
  const links = isInActiveUser ? [
    { name: headerText?.dropDown?.allProjector || 'All Projectors', link: Pathname.access },
    { name: headerText?.dropDown?.contentDashboard || 'Content Dashboard', link: Pathname.dashboard },
    { name: headerText?.dropDown?.accountSetting || 'Account Settings', link: Pathname.getSettingsPath(Pathname.settings.billings) },
    { name: headerText?.dropDown?.terms || 'Privacy and Terms', link: Pathname.getSettingsPath(Pathname.settings.privacy), target: '_blank' },
    { name: headerText?.dropDown?.helpCenter || 'Help Center', link: 'https://projector.help/', type: 'help', target: '_blank' },
    { name: 'Watch Tutorials', link: Pathname.getFriendProfilePath('1') },
    { name: headerText?.dropDown?.logOut || 'Log Out', link: Pathname.authentication.newsignIn, onClick: () => { logout(); } },
  ] : afflitedRes === 0 ? [
    { name: headerText?.dropDown?.allProjector || 'All Projectors', link: Pathname.access },
    { name: headerText?.dropDown?.contentDashboard || 'Content Dashboard', link: Pathname.dashboard },
    { name: headerText?.dropDown?.accountSetting || 'Account Settings', link: Pathname.getSettingsPath(Pathname.settings.accounts) },
    { name: headerText?.dropDown?.tvLogin || 'TV Login', link: Pathname.tvLogin },
    { name: headerText?.dropDown?.terms || 'Privacy and Terms', link: Pathname.getSettingsPath(Pathname.settings.privacy), target: '_blank' },
    // { name: headerText?.dropDown?.termsOfService || 'Terms of Service', link: Pathname.getSettingsPath(Pathname.termsAndConditions), target: '_blank' },
    // { name: headerText?.dropDown?.subscriberAgreement || 'Subscriber Agreement', link: Pathname.getSettingsPath(Pathname.settings.subscriberAgreement), target: '_blank' },
    { name: headerText?.dropDown?.helpCenter || 'Help Center', link: 'https://projector.help/', type: 'help', target: '_blank' },
    { name: 'Watch Tutorials', link: Pathname.getFriendProfilePath('1') },
    { name: headerText?.dropDown?.logOut || 'Log Out', link: Pathname.authentication.newsignIn, onClick: () => { logout(); } },
  ] : [
    { name: headerText?.dropDown?.allProjector || 'All Projectors', link: Pathname.access },
    { name: headerText?.dropDown?.contentDashboard || 'Content Dashboard', link: Pathname.dashboard },
    { name: headerText?.dropDown?.accountSetting || 'Account Settings', link: Pathname.getSettingsPath(Pathname.settings.accounts) },
    { name: headerText?.dropDown?.tvLogin || 'TV Login', link: Pathname.tvLogin },
    { name: headerText?.dropDown?.terms || 'Privacy and Terms', link: Pathname.getSettingsPath(Pathname.settings.privacy), target: '_blank' },
    { name: headerText?.dropDown?.helpCenter || 'Help Center', link: 'https://projector.help/', type: 'help', target: '_blank' },
    { name: 'Affiliate Program', typeOf: 'dropdown', link: '/settings/manage-users', beta: true },
    { name: 'Watch Tutorials', link: Pathname.getFriendProfilePath('1') },
    { name: headerText?.dropDown?.logOut || 'Log Out', link: Pathname.authentication.newsignIn, onClick: () => { logout(); } },
  ];

  const rightLinks = [
    { name: headerText?.dropDown?.contentDashboard || 'Content Dashboard', link: Pathname.dashboard },
    { name: headerText?.dropDown?.accountSetting || 'Account Settings', link: isInActiveUser ? Pathname.getSettingsPath(Pathname.settings.billings) : Pathname.getSettingsPath(Pathname.settings.accounts) },
    { name: 'Watch Tutorials', link: Pathname.getFriendProfilePath('1') },
    { name: headerText?.dropDown?.logOut || 'Log Out', link: Pathname.authentication.newsignIn, onClick: () => { logout(); } },
  ];
  const profiles = userConnections;
  const [uploadModalIsVisible, setUploadModalVisibility] = useState(false);

  const [accessRequestModalIsVisible, setAccessRequestModalVisibility] = useState(false);
  const [accessGrantModalIsVisible, setAccessGrantModalVisibility] = useState(false);
  const [referFriendModalIsVisible, setReferFriendModalVisibility] = useState(false);

  const [profileMenuIsVisible, setProfileMenuVisibility] = useState(false);
  const [profileMenuAnchorEl, setProfileMenuAnchorEl] = useState(null);
  // New-UI avatar dropdown — just the 4 icons pulled off the pill nav
  // (Content Dashboard / TV Login / Watch Tutorials / Help Center).
  const [navMenuAnchor, setNavMenuAnchor] = useState(null);
  const [pageHasScrolled, setPageScroll] = useState(false);
  const [pastUploadSection, setPastUploadSection] = useState(false);
  const [menuItem, setMenuItem] = useState('');
  const [clearing, setClearing] = useState(false);
  const [processingInfo, setProcessingInfo] = useState(false);

  const [userList, setUserList] = useState(profiles);
  const [isStorageFull, setStorageFull] = useState(false);
  const [isOpenPopupModal, setOpenPopupModal] = useState(false);
  const [selectedTab, selectTab] = useState('home');
  const [isMouseOver, setMouseOver] = useState(null);
  const storageFullCondition = parseInt(subscriptionDetails?.storageUsed?.used_storage, 10) === parseInt(subscriptionDetails?.storageUsed?.total_storage, 10);
  const viewerLimitCondition = parseInt(subscriptionDetails?.subscription?.is_unlimited, 10) !== 1 && parseInt(subscriptionDetails?.total_viewers, 10) >= parseInt(subscriptionDetails?.subscription?.max_view_request, 10);

  // Surface the storage alert only for free-plan users over 15GB or 5 files.
  // (used_storage is in MB.) This replaces the old blanket "92% full" seed, so
  // paid plans and new/minimal accounts see nothing.
  useEffect(() => {
    const usedMb = parseInt(subscriptionDetails?.storageUsed?.used_storage, 10) || 0;
    const fileCount = (parseInt(userDetails?.totalVideoUploaded, 10) || 0)
      + (parseInt(userDetails?.totalPhotoUploaded, 10) || 0);
    alertStore.syncStorageAlert({
      isFreePlan: IsfreePlan,
      usedStorageGb: usedMb / 1024,
      fileCount,
    });
  }, [subscriptionDetails, userDetails, IsfreePlan]);
  const getFriendProfile = async () => {
    setProfileLoader(true);
    // getUserContents does not return display_name, so pull it from the
    // getAllViewRequestSent list (userConnections) by matching the profile id.
    const connectionDisplayName = userConnections
      ?.find((connection) => String(connection.id) === String(profileID))?.display_name;
    await axios
      .post(endpoints.getUserContents, { user_id: profileID })
      .then(({ data }) => {
        if (data.success) {
          setProfileDetails({
            firstname: data.freind.firstname,
            lastname: data.freind.lastname,
            display_name: connectionDisplayName || data.freind.display_name,
            email: data.freind.email,
            image: data.freind.image
          });
          setProfileName(connectionDisplayName || data.freind?.firstname?.substring(0, 10) || data.freind?.email?.split('@')[0]?.substring(0, 10));
        } else {
          setProfileDetails({
            firstname: userDetails.firstname,
            lastname: userDetails.lastname,
            display_name: userDetails.display_name,
            email: userDetails.email,
            image: userDetails.dpURL
          });
          setProfileName(userDetails.firstname?.substring(0, 10) || userDetails.email?.split('@')[0]?.substring(0, 10));
        }
      })
      .catch((error) => {
        setProfileDetails({
          firstname: userDetails.firstname,
          lastname: userDetails.lastname,
          display_name: userDetails.display_name,
          email: userDetails.email,
          image: userDetails.dpURL
        });
        setProfileName(userDetails.firstname?.substring(0, 10) || userDetails.email?.split('@')[0]?.substring(0, 10));
      });
    setProfileLoader(false);
  };

  // useEffect(() => {
  //   if (uploadModalIsVisible) document.body.classList.add('modal-open');
  //   else document.body.classList.remove('modal-open');
  //   const handleWheel = (event) => {
  //     if (uploadModalIsVisible) {
  //       event.preventDefault();
  //     }
  //   };
  //   document.addEventListener('wheel', handleWheel, { passive: false });
  //   return () => {
  //     document.removeEventListener('wheel', handleWheel);
  //   };
  // }, [uploadModalIsVisible]);

  const updateYourProfileDetails = () => {
    const newData = profiles.filter((profile) => profile.id !== '1').slice(0);
    const yourProjector = {
      firstname: (headerText?.your || 'Your'),
      lastname: (headerText?.projector || 'Projector'),
      email: userDetails.email,
      image: userDetails.dpURL,
      type: 'self'
    };
    newData.splice(0, 0, yourProjector);
    setUserList(newData);
  };
  const hideProfileMenu = () => { setProfileMenuAnchorEl(null); setProfileMenuVisibility(false); };
  const updateUserDetails = (firstname, lastname, email, id, image, type, displayName) => {
    setdataOfCategory();
    setamICalled(!amICalled);
    if (type === 'self') {
      setProfileDetails({
        firstname: userDetails.firstname,
        lastname: userDetails.lastname,
        display_name: userDetails.display_name,
        email: userDetails.email,
        image: userDetails.dpURL
      });
      setProfileName(userDetails.firstname?.substring(0, 10) || userDetails.email?.split('@')[0]?.substring(0, 10));
    } else {
      // display_name has to be carried through: picking the projector that is
      // already open leaves profileID unchanged, so the getFriendProfile()
      // effect does not re-run and this is the only write to profileDetails.
      // Dropping it here is what made the title fall back to the person's name.
      setProfileDetails({ firstname, lastname, email, image, display_name: displayName });
    }
    hideProfileMenu();
  };
  useEffect(() => {
    if (profileID) {
      getFriendProfile();
    } else {
      setProfileDetails({
        firstname: userDetails.firstname,
        lastname: userDetails.lastname,
        display_name: userDetails.display_name,
        email: userDetails.email,
        image: userDetails.dpURL
      });
      setProfileName(userDetails.firstname?.substring(0, 10) || userDetails.email?.split('@')[0]?.substring(0, 10));
    }
  }, [profileID]);
  useEffect(() => { updateYourProfileDetails(); }, [profiles]);

  // hide upload modal after multiple files upload started
  useEffect(() => {
    if (showProgressBox) {
      setUploadModalVisibility(false);
      setOpenPhotoUploadModal(false);
    }
  }, [showProgressBox]);
  const isPleaseWait = Object.values(uploadPosition).includes('completed');
  const is100 = Object.values(uploadPosition).includes(100);
  useEffect(() => {
    if (userDetails?.isSubscription === null && (isPleaseWait === true || is100)) {
      setisCompleted('completed');
    }
  }, [isPleaseWait]);
  const revealVideoUploadModal = () => {
    setVideoGroup([]);
    setUploaderLoader(true);
    localStorage.setItem('opened_draft_id', null);
    autoSignIn().then((res) => {
      const uploaded = (res?.data?.totalContentUploaded || 0) + uploadManager.getCurrentlyUploadingCount();
      // Free / no-plan: blocked outright when the allowance is 0, else at the cap.
      if (isFreeUploadBlocked(IsfreePlan, uploaded, hasReachedStorageLimit)) {
        setPopUpModalVisible(true);
      } else {
        setOpenNewUploadModal(true);
      }
    }).finally(() => {
      setUploaderLoader(false);
    });
  };
  const revealUploadModal = () => {
    setVideoGroup([]);
    setUploaderLoader(true);
    localStorage.setItem('opened_draft_id', null);
    // setUploadModalVisibility(true);
    autoSignIn().then((res) => {
      const uploaded = (res?.data?.totalContentUploaded || 0) + uploadManager.getCurrentlyUploadingCount();
      // Free / no-plan: blocked outright when the allowance is 0, else at the cap.
      if (isFreeUploadBlocked(IsfreePlan, uploaded, hasReachedStorageLimit)) {
        setPopUpModalVisible(true);
      } else {
        setUploadModalVisibility(true);
      }
    });
  };
  const hideUploadModal = () => {
    setUploadModalVisibility(false);
    // navigate(location.pathname);
  };

  const revealPhotoUploadModal = () => {
    setVideoGroup([]);
    setUploaderLoader(true);
    localStorage.setItem('opened_draft_id', null);
    autoSignIn().then((res) => {
      const uploaded = (res?.data?.totalContentUploaded || 0) + uploadManager.getCurrentlyUploadingCount();
      // Free / no-plan: blocked outright when the allowance is 0, else at the cap.
      if (isFreeUploadBlocked(IsfreePlan, uploaded, hasReachedStorageLimit)) {
        setPopUpModalVisible(true);
      } else {
        setOpenPhotoUploadModal(true);
      }
    });
  };

  const hidePhotoUploadModal = () => {
    setOpenPhotoUploadModal(false);
  };
  const revealAccessRequestModal = () => {
    // if (subscriptionDetails ? subscriptionDetails.subscription === 'Free' : false) {
    //   setAppSnackbar({ isVisible: true, type: 'error', message: 'You must have active plan to a profile' });
    //   navigate(Pathname.plans);
    // } else {
    //   setAccessRequestModalVisibility(true);
    // }
    setAccessRequestModalVisibility(true);
  };
  const hideAccessRequestModal = () => { setAccessRequestModalVisibility(false); navigate(location.pathname); };
  // /access and /profile (own + friend profiles) are the dark-themed pages that
  // open this modal, and there the popup has to match the page's frosted-dark
  // panel. Keyed off the pathname (not the `?request-access` query) so the skin
  // doesn't flip to white mid-close, when hideAccessRequestModal strips the query.
  const isDarkAccessPage = (() => {
    const path = (location.pathname || '').replace(/\/+$/, '');
    return path === Pathname.access
      || path === Pathname.profile.basePath
      || path.startsWith(`${Pathname.profile.basePath}/`);
  })();

  const revealAccessGrantModal = () => {
    setAccessGrantModalVisibility(true);
  };
  const hideAccessGrantModal = () => { setAccessGrantModalVisibility(false); navigate(location.pathname); };
  const revealProfileMenu = (dropDownData) => (e) => {
    setProfileMenuAnchorEl(e.currentTarget);
    setProfileMenuVisibility(true);
    setMenuItem(dropDownData);
  };
  const revealReferFriendModal = () => {
    setReferFriendModalVisibility(true);
  };

  const hideInviteFriendModal = () => {
    setReferFriendModalVisibility(false);
    navigate(location.pathname);
  };
  useEffect(() => {
    if (location.pathname?.includes('search')) {
      selectTab('search');
    } else if (location.pathname?.includes('watchlist')) {
      selectTab('watchlist');
    } else if (location.pathname?.includes('profile')) {
      selectTab('home');
    }
  }, [location.pathname]);

  useEffect(() => {
    if (location.search?.includes(Pathname.uploadVideo)) {
      revealUploadModal();
    } else if (location.search?.includes(Pathname.requestAccess)) {
      revealAccessRequestModal();
    } else if (location.search?.includes(Pathname.grantAccess)) {
      if (viewerLimitCondition) {
        setStorageFull(true); navigate(location.pathname);
      } else {
        revealAccessGrantModal();
      }
    } else if (location.search?.includes(Pathname.referFriend)) {
      revealReferFriendModal();
    } else if (location.search?.includes(Pathname.upgradePlan) /* || location.search?.includes(Pathname.processingInBackGround) */) {
      setStorageFull(true); navigate(location.pathname);
    }
    // if (location.search?.includes(Pathname.processingInBackGround)) {
    //   setProcessingInfo(true);
    // }
  }, [location.search]);
  useEffect(() => {
    const scrollHandler = () => {
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      setPageScroll(y > 0);
      // ~height of the greeting + upload section; past this the nav shows Upload.
      setPastUploadSection(y > 360);
    };
    scrollHandler();

    window.addEventListener('scroll', scrollHandler, { passive: true });

    return () => { window.removeEventListener('scroll', scrollHandler); };
  }, []);

  // slim V2 header: start full-height, then automatically collapse to a
  // compact bar after a short settle delay. (On scroll it further morphs into
  // a floating pill — that part is pure CSS keyed off `.pageScrolled`.)
  const [slimCompact, setSlimCompact] = useState(false);
  useEffect(() => {
    if (!slimPill) { setSlimCompact(false); return undefined; }
    const t = setTimeout(() => setSlimCompact(true), 2500);
    return () => clearTimeout(t);
  }, [slimPill]);
  const grantProfileAccess = async ([onHide, setActionStatus, setOperationStatus, setSelectedUsers, setUserList, users]) => {
    setActionStatus(true);
    const uniqueUsers = users.filter((user, index, self) => index === self.findIndex((u) => u.email === user.email));
    const { data: grantAccessData } = await axios
      .post(endpoints.addViewer, {
        data: uniqueUsers.map((data) => ({ ...data, firstName: data.firstname, lastName: data.lastname }))
      })
      .catch(() => ({}));
    setUserList([]);
    if (grantAccessData?.success) {
      // Ticks "Invite User" off the dashboard getting-started checklist.
      markSectionExplored(EXPLORED_SECTION.invite);
      setSelectedUsers([]);
      setOperationStatus(true);
      onHide();
      setViewerListUpdate(true);
    } else {
      setOperationStatus(false);
    }
    setActionStatus(false);
  };

  const sendInvitation = async ([onHide, setActionStatus, setOperationStatus, setSelectedUsers, setUserList, users]) => {
    setActionStatus(true);
    const response = await axios
      .post(endpoints.sendReferralInvitation, {
        email: users[0].email
      })
      .catch((error) => {
        setErrorMsg(error?.response?.data?.message);
        setOperationStatus(false);
      });
    setUserList([]);
    if (response?.data?.success) {
      setSelectedUsers([]);
      setOperationStatus(true);
      onHide();
    } else {
      setOperationStatus(false);
    }
    setActionStatus(false);
  };
  const requestProfileAccess = async ([onHide, setActionStatus, setOperationStatus, setSelectedUsers, setUserList, users]) => {
    setActionStatus(true);

    // Separate users with IDs from users with emails only
    const usersWithIds = users.filter((userData) => userData.id && userData.id !== userData.email);
    const usersWithEmailsOnly = users.filter((userData) => !userData.id || userData.id === userData.email);

    // Create request payload
    const requestPayload = {};
    if (usersWithIds.length > 0) {
      requestPayload.users = `${usersWithIds.map((userData) => userData.id)}`;
    }
    if (usersWithEmailsOnly.length > 0) {
      requestPayload.emails = `${usersWithEmailsOnly.map((userData) => userData.email)}`;
    }

    const { data: requestProfileAccessData } = await axios
      .post(endpoints.sendViewRequest, requestPayload)
      .catch(() => ({}));

    setUserList([]);

    if (requestProfileAccessData?.success) {
      setSelectedUsers([]);
      setOperationStatus(true);
      onHide();
    } else {
      setOperationStatus(false);
    }
    setAppSnackbar({ isVisible: true, type: 'success', message: 'Request placed successfully' });
    setActionStatus(false);
  };
  const updateNotificationStatus = async (id, read_all, getMyNotifications) => {
    setClearing(true);
    await axios
      .post(endpoints.updateMyNotifications, { id, read_all, status: '2' })
      .then((response) => {
        getMyNotifications();
        // setClearing(false);
      })
      .catch((error) => {
        setClearing(false);
      });
  };

  const handlePushNotification = ({ id, message, status }) => {
    // updateNotificationStatus(id, '3');
    updateNotificationStatus(id, true);
    store.addNotification({
      content: function Data() {
        return (
          <>
            <NotificationSound />
            <div
              style={{
                background: `linear-gradient(180deg,${status === '0' ? '#139ff0 0,#007fed' : '#2df013 0,#43d04f'})`,
                color: 'white',
                borderRadius: '.5rem',
                padding: '10px 5px'
              }}
              onClick={() => {
                updateNotificationStatus(id, 2);
                navigate(Pathname.dashboard);
              }}
            >
              <span>{message}</span>
              <hr />
              <small style={{ fontSize: '12px' }}>This message will be dismissed in 5 seconds</small>
            </div>

          </>
        );
      },
      container: 'top-left',
      insert: 'top',
      dismiss: {
        duration: 5000,
      },
    });
  };
  const onLinkClick = (e) => {
    e.preventDefault();
    navigate(Pathname.getProfilePath());
    setdataOfCategory();
  };
  const spinerSmall = 'spinex';
  const lastPlan = subscriptionDetails?.plans?.length
    ? subscriptionDetails.plans[subscriptionDetails.plans.length - 1]
    : null;

  const shouldRedirect = (
    (isInActiveUser && lastPlan?.is_trial === '0')
    // || subscriptionDetails?.current_plan === 'Free'
    // || subscriptionDetails?.subscription === null
  );
  // Projector switcher given the reactbits Card Nav treatment on /profile (left
  // of the floating pill). Trigger names the PERSON whose projector is open —
  // the projector's own name is the title on the right — while the card stack
  // shows the other projector profiles (same userList as the profile menu), and
  // a footer carries the nav actions + logout.
  const switcherPersonName = getHeaderName(profileDetails) || 'Projector';
  const projectorAvatar = profileDetails?.image || projectorImage;
  const projectorProfiles = (userList || []).map((u) => {
    const first = u.firstname === 'Your' ? userDetails?.firstname : u.firstname;
    const last = u.firstname === 'Your' ? userDetails?.lastname : u.lastname;
    return {
      id: u.id,
      name: u.display_name || `${first || ''} ${last || ''}`.trim() || u.email,
      image: u.image,
      isCurrent: String(u.id) === String(profileID),
      raw: u,
    };
  });
  const handleSelectProjector = (p) => {
    const u = p.raw || {};
    if (p.isCurrent) return;
    const target = `${Pathname.getFriendProfilePath(u.id)}${giftSuffix}`;
    // Theme colour of the projector being opened (falls back to the default
    // aurora when the account hasn't set one).
    const themeColor = normalizeBg(
      (Array.isArray(u?.settings) ? u.settings[0]?.projector_background : u?.settings?.projector_background)
      || u?.projector_background || '',
    );
    // Lights-dimming transition: the aurora "Setting …'s Projector account for
    // you" overlay lives on document.body so it survives the route remount and
    // stays up across the switch + the next page's load (hiding the shimmer).
    showProjectorSwitchOverlay({ name: p.name, color: themeColor });
    setTimeout(() => {
      navigate(target);
      try {
        updateUserDetails(u.firstname, u.lastname, u.email, u.id, u.image, u.type, u.display_name);
      } catch (e) {
        // best-effort optimistic update; navigation already performed the switch
      }
    }, 600);
    // Keep the loader on ~2.4s total, then fade out over ~0.55s.
    hideProjectorSwitchOverlay(2400);
  };
  // Own-projector section jump (Categories / Playlists / Albums) — moved here
  // from the page's left-edge OptionWheel so it's visible in the top nav.
  // Matches Pages/private/profile/index.jsx's own handleScrollToSection offset.
  const scrollToProfileSection = (id) => {
    const el = document.getElementById(`section-${id}`);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 96;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }
  };
  // Same content_type_id -> section mapping/order source as
  // Pages/private/profile/index.jsx, so these pills stay in sync with the
  // actual layout order of the sections rendered below.
  const sectionNavConfig = {
    1: { id: 'categories', label: 'Categories', Icon: AnimatedCategory, hoverKey: 'cat' },
    2: { id: 'playlist', label: 'Playlists', Icon: AnimatedPlaylist, hoverKey: 'pl' },
    3: { id: 'albums', label: 'Albums', Icon: AnimatedAlbum, hoverKey: 'al' },
  };
  const defaultSectionOrder = [
    { content_type_id: 1, order_number: 1 },
    { content_type_id: 2, order_number: 2 },
    { content_type_id: 3, order_number: 3 },
  ];
  const layoutProfileId = profileID || userDetails?.myId;
  const profileSectionOrder = orderArrange?.[Number(layoutProfileId)]?.length
    ? [...orderArrange[Number(layoutProfileId)]]
    : defaultSectionOrder;
  const sortedSectionNav = [...profileSectionOrder]
    .sort((a, b) => Number(a?.order_number) - Number(b?.order_number))
    .map(({ content_type_id }) => sectionNavConfig[content_type_id])
    .filter(Boolean);
  const projectorFooterLinks = [
    { label: 'All Projectors', Icon: AnimatedProjector, onClick: () => navigate(Pathname.access) },
    { label: 'Request access', Icon: AnimatedLock, onClick: () => revealAccessRequestModal() },
    { label: 'Content Dashboard', Icon: AnimatedLayoutGrid, onClick: () => navigate(Pathname.dashboard) },
    // On viewer pages, Upload / Notifications / TV move out of the icon row and
    // into this dropdown.
    ...(isViewerNav ? [
      { label: 'Upload', Icon: AnimatedUpload, onClick: () => navigate(Pathname.getStoragePath(Pathname.storage.videos)) },
      { label: 'Notifications', Icon: AnimatedBell, onClick: () => navigate(Pathname.getSettingsPath(Pathname.settings.notifications)) },
      { label: 'TV Login', Icon: AnimatedTv, onClick: () => navigate(Pathname.tvLogin) },
    ] : []),
  ];

  return (
    <>
      <ReactNotification styles={{ zIndex: 999999, width: '100%' }} />
      <header
        className={cn({
          [styles.glassCompactHeaderBG]: glassCompactHeaderBG,
          [styles.header]: true,
          [styles.slimV2]: slimPill,
          [styles.pillHiddenOnScroll]: slimPill && scrollCondensed,
          [styles.railAligned]: slimPill && hasFloatingSidebar,
          [styles.profilePill]: isProfilePage && slimPill,
          [styles.slimV2Compact]: slimPill && slimCompact,
          [styles.noHeader]: noHeader,
          [styles.noRegularHeader]: noRegularHeader || (isProfileHeader && !isProfilePage),
          [styles.pageScrolled]: pageHasScrolled,
          [styles.transparentCompactView]: transparentCompactHeader,
          [styles.headerTheme]: !location.pathname.includes('/profile')
            // && !location.pathname.includes('/access')
            // && location.pathname !== '/'
            // && location.pathname !== ''
            && !location.pathname.includes('/plan')
            && !location.pathname.includes('/newSign-in')
            && !location.pathname.includes('/getting-started')
        })}
      >
        {
          (location.pathname.includes('/access') || location.pathname === '/' || location.pathname === '') ? (
            <div className={styles.semiOvalWrap}>
              <div className={styles.box} />
            </div>
          ) : null
        }
        <div className={styles.headerContent}>
          {isViewerNav ? (
            <div className={styles.viewerNavGroup}>
              <button
                type="button"
                title="Back"
                aria-label="Back"
                onClick={() => {
                  // From the projector's /profile → back to /access. From the
                  // viewer sub-pages (search / watchlist / innerpage) → back to
                  // that projector's /profile.
                  if (isProfilePage) { navigate(Pathname.access); return; }
                  if (profileID) { navigate(Pathname.getFriendProfilePath(profileID)); return; }
                  const prev = sessionStorage.getItem('navigateProfile');
                  if (prev) { navigate(prev); return; }
                  const pid = sessionStorage.getItem('skipProfileRefetch');
                  if (pid && pid !== 'undefined') { navigate(Pathname.getFriendProfilePath(pid)); return; }
                  navigate(-1);
                }}
                className="ownavCircle"
              >
                <AnimatedChevronLeft size={20} />
              </button>
              {(isProfilePage || profileID) ? (
                <ProjectorCardNav
                  currentName={switcherPersonName}
                  currentImage={projectorAvatar}
                  profiles={projectorProfiles}
                  onSelectProfile={handleSelectProjector}
                  footerLinks={projectorFooterLinks}
                />
              ) : (
                <Link className={styles.regularView} to={Pathname.access}>
                  <Logo />
                </Link>
              )}
              <button
                type="button"
                title="Search"
                aria-label="Search"
                onClick={() => navigate(Pathname.getFriendSearch(profileID))}
                className="ownavCircle"
              >
                <AnimatedSearch size={20} />
              </button>
              <button
                type="button"
                title="Watchlist"
                aria-label="Watchlist"
                onClick={() => navigate(Pathname.getFriendWatchList(profileID))}
                className="ownavCircle"
              >
                <AnimatedBookmarkPlus size={20} />
              </button>
              {/* Quick-jump to this projector's sections — was the left-edge
                  OptionWheel, now lives in the top nav alongside Search/Watchlist. */}
              {isProfilePage && sortedSectionNav.map((nav) => (
                <button
                  key={nav.id}
                  type="button"
                  title={nav.label}
                  aria-label={nav.label}
                  onClick={() => scrollToProfileSection(nav.id)}
                  className="ownavSectionPill"
                  onMouseEnter={() => setHoveredPill(nav.hoverKey)}
                  onMouseLeave={() => setHoveredPill(null)}
                >
                  <nav.Icon size={18} animate={hoveredPill === nav.hoverKey} />
                  {nav.label}
                </button>
              ))}
            </div>
          ) : (
            <Link className={styles.regularView} to={Pathname.access}>
              <Logo />
            </Link>
          )}
          {hideMenu
            ? <>&nbsp;</>
            : (
              <button className={cn({ [styles.menuButton]: true, [styles.compactView]: true })} onClick={onMenuClick}>
                <MenuIcon className={styles.menuIcon} />
              </button>
            )}

          {/* Mobile search bar - right of hamburger */}
          {isProfileHeader && (
            <div
              className={cn({ [styles.mobileHeaderSearch]: true, [styles.compactView]: true })}
              onClick={() => navigate(Pathname.getFriendSearch(profileID))}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === 'Enter') navigate(Pathname.getFriendSearch(profileID)); }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="rgba(255,255,255,0.5)">
                <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
              </svg>
              <span className={styles.mobileHeaderSearchText}>Search videos...</span>
            </div>
          )}

          <div className={styles.options}>
            {(!location.search.includes('?cancel-subscription')) && (
              <>
                {(!isViewerNav || isOwnProjectorView) && !isInActiveUser && (!hideNavUploadUntilScroll || pastUploadSection) ? (
                  <UploadDropdown
                    onVideoUpload={revealVideoUploadModal}
                    onPhotoUpload={revealPhotoUploadModal}
                    disabled={
                      draftcontent?.length > 0
                      || uploaderLoader === true
                      || holdWhileDelete === true
                    }
                    isLoading={uploaderLoader}
                    className={cn({
                      [styles.regularView]: true,
                      [styles.uploadButtonHover]: !(draftcontent?.length > 0 || uploaderLoader === true || holdWhileDelete === true),
                      [styles.disableduploadButton]: (draftcontent?.length > 0 || uploaderLoader === true || holdWhileDelete === true),
                    }, 'ownavSectionPill')}
                    showCloudOptions /* private_plan_access gate disabled for now — cloud options shown for all users. Was: {apiResponse?.data?.[0]?.private_plan_access === '1' || apiResponse?.data?.[0]?.private_plan_access === 1 || (userAccessedData && managerPrivatePlanAccess)} */
                  />
                ) : null}
                {!isViewerNav && !shouldRedirect ? (
                  (location.pathname === '/access' || isProfilePage) ? (
                    // On All Projectors (/access) and the user's Projector (/profile),
                    // the pill jumps to the Content Dashboard.
                    <Link
                      style={{ margin: 0 }}
                      title="Content Dashboard"
                      aria-label="Content Dashboard"
                      className="ownavSectionPill"
                      to={Pathname.dashboard}
                      onMouseEnter={() => setHoveredPill('contentDash')}
                      onMouseLeave={() => setHoveredPill(null)}
                    >
                      <AnimatedLayoutGrid size={18} animate={hoveredPill === 'contentDash'} />
                      Content Dashboard
                    </Link>
                  ) : (
                    // Everywhere else, the pill goes to All Projectors (/access).
                    <Link
                      style={{ margin: 0 }}
                      title="All Projectors"
                      aria-label="All Projectors"
                      className="ownavSectionPill"
                      to={Pathname.access}
                      onMouseEnter={() => setHoveredPill('allProj')}
                      onMouseLeave={() => setHoveredPill(null)}
                    >
                      <AnimatedProjector size={18} animate={hoveredPill === 'allProj'} />
                      All Projectors
                    </Link>
                  )
                ) : null}
                {!isViewerNav && !shouldRedirect && (location.pathname !== '/access' && location.pathname !== '/profile') ? (
                  <Link
                    style={{ margin: 0 }}
                    title="View Your Projector"
                    className={cn({
                      [styles.profileMenuLink]: true,
                      [styles.myProjectorLink]: true,
                    }, 'ownavViewproj ownavCircle')}
                    to={Pathname.getProfilePath()}
                    onClick={onLinkClick}
                  >
                    <ClapUploadIcon size={20} />
                  </Link>
                ) : null}
                {/* {userDetails.totalVideoUploaded > 0
                  ? (
                    <Link
                      style={{ margin: 'auto 1rem ' }}
                      className={`${styles.profileMenuLink} ${styles.uploadText} ${styles.fontBold} ${styles.myProjectorLink}`}
                      to={Pathname.getProfilePath()}
                    >
                      View my projector
                    </Link>
                  )
                  : null} */}
                {/* {
                  !isInActiveUser ? (
                    <button
                    className={cn({
                      [styles.uploadButton]: true,
                      [styles.regularView]: true,
                      [styles.uploadButtonHover]: !(draftcontent?.length > 0 || uploaderLoader === true || holdWhileDelete === true), // Conditionally apply hover
                      [styles.disableduploadButton]: (draftcontent?.length > 0 || uploaderLoader === true || holdWhileDelete === true),
                        // !(isHeTrial10) && (draftcontent?.length > 0 || uploaderLoader === true || activeUploads?.length > 0),
                    })}
                      onClick={revealUploadModal}
                    // onClick={() => {
                    //   if (isHeTrial10) {
                    //     revealUploadModal(); // Allow revealUploadModal for isHeTrial10
                    //   } else if (!(activeUploads?.length > 0)) {
                    //     revealUploadModal(); // Allow revealUploadModal when no active uploads
                    //   } else {
                    //     setAppSnackbar({
                    //       isVisible: true,
                    //       type: 'error',
                    //       message: 'You have ongoing uploads, please add new files after they\'re complete',
                    //     });
                    //   }
                    // }}
                    disabled={
                      // (!isHeTrial10 && (uploadContainer?.length > 0 && userDetails?.isSubscription === null))
                      draftcontent?.length > 0
                      || uploaderLoader === true
                      || holdWhileDelete === true
                    }
                    >
                      <span className={styles.uploadText} style={{ marginRight: uploaderLoader === true ? '10px' : '' }}>{headerText?.upload || 'Upload'}</span>
                      {uploaderLoader === true
                      ? (<Spinner spinex={spinerSmall} />)
                      : (<div className={styles.uploadIcon}>+</div>
                      )}
                    </button>
                  ) : null
                } */}
                {(!isViewerNav || isOwnProjectorView) && (
                  <Notifications
                    handlePushNotification={handlePushNotification}
                    updateNotificationStatus={updateNotificationStatus}
                    getUserConnections={getUserConnections}
                    clearing={clearing}
                    setClearing={setClearing}
                  />
                )}
                {slimPill && showNavAlert && (
                  <button
                    type="button"
                    title="View alerts"
                    aria-label="View alerts"
                    onClick={() => alertStore.showBanner()}
                    style={{ margin: 0 }}
                    className={cn({
                      [styles.profileMenuLink]: true,
                      [styles.myProjectorLink]: true,
                    }, 'ownavAlert ownavCircle')}
                  >
                    <AnimatedAlertTriangle size={20} />
                  </button>
                )}
              </>
            )}

            <button
              aria-controls="profile-menu"
              title="Settings"
              className={cn({ [styles.profileButton]: true, [styles.regularView]: true }, 'ownavAvatar')}
              onClick={(e) => setNavMenuAnchor(e.currentTarget)}
            >

              {
                userDetails?.dpURL ? (
                  <img
                    onError={(e) => {
                      e.target.src = AlterImage;
                    }}
                    // draggable={false}
                    className={`${styles.profileMenuCurrentProfileDetailsIcon} ${styles.border}`}
                    src={userDetails?.dpURL || AlterImage}
                  />
                )
                  : <PersonIcon className={`${styles.profileMenuCurrentProfileDetailsIcon} ${styles.border2}`} />
              }
            </button>
            <button
              title="Settings"
              className={cn({ [styles.profileButton]: true, [styles.compactView]: true })}
              onClick={(e) => setNavMenuAnchor(e.currentTarget)}
            >
              {
                userDetails?.dpURL ? (
                  <img
                    className={styles.profileMenuCurrentProfileDetailsIcon}
                    src={userDetails?.dpURL || AlterImage}
                    onError={(e) => {
                      e.target.src = AlterImage;
                    }}
                  />
                )
                  : <PersonIcon className={styles.profileIcon} />
              }
            </button>
          </div>
        </div>
      </header>
      <MuiMenu
        anchorEl={navMenuAnchor}
        open={Boolean(navMenuAnchor)}
        onClose={() => setNavMenuAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            mt: 1,
            minWidth: 220,
            borderRadius: 3,
            bgcolor: 'rgba(18,20,28,0.92)',
            backdropFilter: 'blur(22px)',
            WebkitBackdropFilter: 'blur(22px)',
            border: '1px solid rgba(255,255,255,0.08)',
            boxShadow: '0 20px 50px rgba(0,0,0,0.5)',
            color: '#f5f5f7',
            p: 0.75,
          },
        }}
        MenuListProps={{ sx: { p: 0 } }}
      >
        <MenuItem
          onClick={() => { setNavMenuAnchor(null); navigate(Pathname.dashboard); }}
          sx={{ borderRadius: 2, py: 1, gap: 1.25, fontSize: 14, fontWeight: 600, fontFamily: "'Montserrat', sans-serif", '&:hover': { bgcolor: 'rgba(255,255,255,0.08)' } }}
        >
          <AnimatedLayoutDashboard size={18} />
          {headerText?.dropDown?.contentDashboard || 'Content Dashboard'}
        </MenuItem>
        <MenuItem
          onClick={() => { setNavMenuAnchor(null); navigate(Pathname.tvLogin); }}
          sx={{ borderRadius: 2, py: 1, gap: 1.25, fontSize: 14, fontWeight: 600, fontFamily: "'Montserrat', sans-serif", '&:hover': { bgcolor: 'rgba(255,255,255,0.08)' } }}
        >
          <AnimatedTv size={18} />
          {headerText?.dropDown?.tvLogin || 'TV Login'}
        </MenuItem>
        <MenuItem
          onClick={() => { setNavMenuAnchor(null); navigate(Pathname.getFriendProfilePath('1')); }}
          sx={{ borderRadius: 2, py: 1, gap: 1.25, fontSize: 14, fontWeight: 600, fontFamily: "'Montserrat', sans-serif", '&:hover': { bgcolor: 'rgba(255,255,255,0.08)' } }}
        >
          <AnimatedGraduationCap size={18} />
          Watch Tutorials
        </MenuItem>
        <MenuItem
          onClick={() => {
            setNavMenuAnchor(null);
            window.open('https://projector.help/', '_blank', 'noopener,noreferrer');
          }}
          sx={{ borderRadius: 2, py: 1, gap: 1.25, fontSize: 14, fontWeight: 600, fontFamily: "'Montserrat', sans-serif", '&:hover': { bgcolor: 'rgba(255,255,255,0.08)' } }}
        >
          <AnimatedHelpCircle size={18} />
          {headerText?.dropDown?.helpCenter || 'Help Center'}
        </MenuItem>
      </MuiMenu>
      <div
        className={cn({
          [styles.headerFill]: true,
          [styles.slimV2]: slimPill,
          [styles.slimV2Compact]: slimPill && slimCompact,
          [styles.noHeader]: noHeader || videoBanner,
          [styles.noRegularHeader]: noRegularHeader || (isProfileHeader && !isProfilePage),
        })}
      />
      {
        videoBanner && layoutData?.length ? (
          <VideoBanner
            layoutData={layoutData}
            profileDetails={profileDetails}
            revealProfileMenu={revealProfileMenu}
            storageFullCondition={storageFullCondition}
            setStorageFull={setStorageFull}
            revealUploadModal={revealUploadModal}
            revealVideoUploadModal={revealVideoUploadModal}
          />
        ) : null
      }
      <header className={cn({ [styles.profileHeader]: true, [styles.hidden]: !isProfileHeader || isProfilePage })}>

        <div className={styles.profileHeaderContent}>

          <div className={styles.leftContent} style={{ flex: '1' }}>
            {
              !location.pathname.includes('/profile')
                ? (
                  // <IconButton>
                  // </IconButton>
                  (
<div
                    // style={{
                    //   // border: 'solid white',
                    //   display: 'flex',
                    //   justifyContent: 'center',
                    //   alignItems: 'center',
                    //   // borderRadius: '9999999999999px',
                    //   padding: '.2rem',
                    //   marginRight: '.5rem'
                    // }}
                    className={`${!location.pathname.includes('/video/') && styles.backButton}`}
>
                    <img
                      src={ArrowBackIos || AlterImage}
                      style={{ color: 'white', cursor: 'pointer', marginRight: '0' }}
                      fontSize="large"
                      onClick={() => navigate(-1)}
                      className={styles.profileHeaderIconButtonIcon}
                      onError={(e) => {
                        e.target.src = AlterImage;
                      }}
                    />
</div>
)
                ) : null
            }
            {!location.pathname.includes('/video') ? (
              <>
                <button
                  aria-controls="profile-menu"
                  className={cn({
                    [styles.profileButton]: true,
                    [styles.regularView]: true,
                    [styles.profileHeaderIconButton]: true,
                  })}
                  onClick={revealProfileMenu('projectors')}
                >
                  {
                    profileDetails.image ? (
                      <img
                        src={profileDetails?.image || AlterImage}
                        className={cn({
                          [styles.profileMenuCurrentProfileDetailsIcon]: true,
                          [styles.border]: true,
                          [styles.profileIconPosition]: true,
                          [styles.profileMouseOver]: isMouseOver === 'profile',
                        })}
                        onMouseEnter={() => { setMouseOver('profile'); }}
                        onMouseLeave={() => { setMouseOver(null); }}
                        onError={(e) => {
                          e.target.src = AlterImage;
                        }}
                      />
                    ) : (
                      <PersonIcon
                        className={cn({
                          [styles.profileMenuCurrentProfileDetailsIcon]: true,
                          [styles.border2]: true,
                          [styles.profileIconPosition]: true,
                          [styles.profileMouseOver]: isMouseOver === 'profile',
                        })}
                        onMouseEnter={() => { setMouseOver('profile'); }}
                        onMouseLeave={() => { setMouseOver(null); }}
                      />
                    )
                  }
                  <div
                    className={`${styles.profileHeaderIconButtonText} ${styles.namePosition} ${isMouseOver === 'profile' ? styles.profileMouseOver : ''}`}
                    onMouseEnter={() => { setMouseOver('profile'); }}
                    onMouseLeave={() => { setMouseOver(null); }}
                  >
                    {getHeaderName(profileDetails)}
                  </div>
                </button>
                <HeaderIconButton
                  iconType="home"
                  setMouseOver={setMouseOver}
                  isMouseOver={isMouseOver}
                  icon={HomeIcon}
                  text={headerText?.home || 'Home'}
                  link={`${profileID ? Pathname.getFriendProfilePath(profileID) : Pathname.getProfilePath()}${giftSuffix}`}
                  selectedTabClass={selectedTab === 'home'}
                />
                <HeaderIconButton
                  iconType="search"
                  icon={SearchIcon}
                  text={headerText?.search || 'Search'}
                  link={Pathname.getFriendSearch(profileID)}
                  setMouseOver={setMouseOver}
                  isMouseOver={isMouseOver}
                  selectedTabClass={selectedTab === 'search'}
                />
                <HeaderIconButton
                  iconType="watchlist"
                  icon={WatchlistIcon}
                  text={headerText?.watchlist || 'Watchlist'}
                  link={Pathname.getFriendWatchList(profileID)}
                  setMouseOver={setMouseOver}
                  isMouseOver={isMouseOver}
                  selectedTabClass={selectedTab === 'watchlist'}
                />
              </>
            )
              : null}
            {/* {(userName && userProfileLink) && (
              <HeaderIconButton
                icon={ProfileIcon}
                text={`${(userName?.length > 16) ? `${userName?.substring(0, 16)}...` : userName}'s Page`}
                link={userProfileLink}
              />
            )} */}
          </div>
          <div className={styles.rightContent}>
            {!location.pathname.includes('/video') ? (
              <>
                {!isInActiveUser ? (
                  <UploadDropdown
                    onVideoUpload={revealVideoUploadModal}
                    onPhotoUpload={revealPhotoUploadModal}
                    disabled={
                      draftcontent?.length > 0
                      || uploaderLoader === true
                      || holdWhileDelete === true
                    }
                    isLoading={uploaderLoader}
                    className={cn({
                      [styles.regularView]: true,
                      [styles.uploadButtonHover]: !(draftcontent?.length > 0 || uploaderLoader === true || holdWhileDelete === true),
                      [styles.disableduploadButton]: (draftcontent?.length > 0 || uploaderLoader === true || holdWhileDelete === true),
                    })}
                    showCloudOptions /* private_plan_access gate disabled for now — cloud options shown for all users. Was: {apiResponse?.data?.[0]?.private_plan_access === '1' || apiResponse?.data?.[0]?.private_plan_access === 1 || (userAccessedData && managerPrivatePlanAccess)} */
                  />
                ) : null}
                <HeaderIconButton
                  aria-controls="profile-menu"
                  text={headerText?.account || 'ACCOUNT'}
                  onClick={revealProfileMenu(null)}
                  link={`${location.pathname}${location.search}`}
                  setMouseOver={setMouseOver}
                  isMouseOver={isMouseOver}
                  iconType="account"
                />
              </>
            ) : null}
          </div>
        </div>
      </header>
      <Menu
        anchorEl={profileMenuAnchorEl}
        id="profile-menu"
        MenuListProps={{ className: styles.profileMenu }}
        onClose={hideProfileMenu}
        open={profileMenuIsVisible}
        PopoverClasses={{ paper: styles.profileMenuContainer }}
      >
        {
          [
            <>
              <div className={cn({ [styles.profileMenuCurrentProfileDetails]: menuItem !== 'projectors' })}>
                {
                  menuItem === 'projectors' ? (
                    <div className={styles.profileMenuCurrentProfileDetailsText}>
                      {profileName}
                    </div>
                  ) : (
                    <>
                      <div className={styles.profileMenuCurrentProfileDetailsText}>
                        {userDetails.firstname?.substring(0, 10) || userDetails.email?.split('@')[0]?.substring(0, 10)}
                      </div>
                      {
                        userDetails?.dpURL !== null ? (
                          <img
                            className={`${styles.profileMenuCurrentProfileDetailsIcon} ${styles.border}`}
                            src={userDetails?.dpURL || AlterImage}
                            onError={(e) => {
                              e.target.src = AlterImage;
                            }}
                          />
                        ) : (
                          <ProfileIcon className={`${styles.profileMenuCurrentProfileDetailsIcon} ${styles.border2}`} />
                        )
                      }
                    </>
                  )
                }
              </div>

              {
                menuItem !== 'projectors' ? <hr className={styles.profileMenuDivider} /> : null
              }
              {
                menuItem === 'account' ? (
                  <div className={styles.profileMenuLinksContainer}>
                    {rightLinks.map(({ name, link, onClick }, idx) => (
                      <Link to={link} key={idx} onClick={onClick} className={styles.profileMenuLink}>{name}</Link>
                    ))}
                  </div>
                ) : menuItem === 'projectors' ? (
                  <>
                    <Link className={styles.profileMenuProfile} to={Pathname.access}>
                      <DehazeIcon className={styles.iconColor} />
                      <div className={cn({ [styles.profileMenuProfileName]: true, [styles.allProjectorAlign]: true })}>
                        {headerText?.allProjector || 'All Projectors'}
                      </div>
                    </Link>
                    <div className={styles.profileMenuProfilesContainer}>
                      {userList.map(({ firstname, lastname, email, id, image, type, display_name }, idx) => (
                        <ProfileMenuProfileButton
                          email={email}
                          Icon={PersonIcon}
                          key={idx}
                          setProfileDetails={setProfileDetails}
                          link={`${Pathname.getFriendProfilePath(id)}${giftSuffix}`}
                          name={display_name || `${firstname} ${lastname}`.trim()}
                          firstname={firstname === 'Your' ? userDetails?.firstname : firstname}
                          lastname={firstname === 'Your' ? userDetails?.lastname : lastname}
                          image={image}
                          isPerson
                          onClick={(e) => { updateUserDetails(firstname, lastname, email, id, image, type, display_name); }}
                        />
                      ))}
                    </div>
                  </>
                ) : (
                  <>
                    {/* {
                location.pathname.includes('/access') ? (
                  <div className={styles.profileMenuProfilesContainer}>
                    {profiles.map(({ firstname, lastname, email, id, image }, idx) => (
                      <ProfileMenuProfileButton
                        email={email}
                        Icon={PersonIcon}
                        key={idx}
                        link={Pathname.getFriendProfilePath(id)}
                        name={`${firstname} ${lastname}`.trim()}
                        image={image}
                        isPerson
                      />
                    ))}
                    <ProfileMenuProfileButton Icon={AddIcon} link="#" name={headerText?.dropDown?.requestAccess || 'Request access'} onClick={revealAccessRequestModal} />
                  </div>
                ) : null
              } */}
                    <div className={styles.profileMenuLinksContainer}>
                      {links.map(({ name, link, onClick, type, typeOf, beta }, idx) => {
                        if (!location.pathname.includes(link)) {
                          if (type === 'help') {
                            return (
                              <a href={link} key={idx} className={styles.profileMenuLink} target="_blank" rel="noreferrer">
                                {name}
                              </a>
                            );
                          }
                          // Match the sidebar banner's visibility — hide the
                          // User Management dropdown only when BOTH the API
                          // says we're in an access session AND the frontend
                          // marker confirms it. Stale /getUserAccess can't
                          // wrongly hide the dropdown anymore.
                          if (typeOf === 'dropdown') {
                            const isImpersonating = getAccessChecker?.success === true
                              && localStorage.getItem('isAccessingUser') === 'true';
                            if (isImpersonating) return null;
                            return (
                              <Link to={link} key={idx} onClick={onClick} className={`${styles.profileMenuLink} ${beta ? styles.profileMenuLinkBadge : ''}`}>
                                {name}
                                {beta && <span className={styles.betaBadge}>New</span>}
                              </Link>
                            );
                          }
                          return (
                            <Link to={link} key={idx} onClick={onClick} className={styles.profileMenuLink}>
                              {name}
                            </Link>
                          );
                        }
                        return null;
                      })}
                      {/* Switch between the new UI and the classic (production)
                          layout. Reloads so the whole app re-reads the flag.
                          Only offered when the backend config allows it. */}
                      {canSwitchUI && (
                      <button
                        type="button"
                        className={styles.profileMenuLink}
                        onClick={() => beginUiSwitch(!isNewUIEnabled(), 'header')}
                        style={{
                          background: 'none', border: 'none', width: '100%', height: 'auto', textAlign: 'left', cursor: 'pointer', padding: 0,
                        }}
                      >
                        {isNewUIEnabled() ? 'Switch to classic layout' : 'Switch to new layout'}
                      </button>
                      )}
                    </div>

                  </>
                )
              }
            </>
          ]
        }
      </Menu>
      <Drawer anchor="right" open={profileMenuIsVisible} className={styles.profileBar} onClose={hideProfileMenu}>
        <div className={styles.profileBarContainer}>
          <div className={styles.profileBarContent}>
            <div className={styles.profileBarProfilesContainer}>
              <div>
                <div className={styles.profileBarProfilesContent}>
                  {profiles.map(({ firstname, lastname, email, id, image, type, display_name }, idx) => (
                    <ProfileDrawerProfileButton
                      email={email}
                      Icon={ProfileIcon}
                      key={idx}
                      link={`${Pathname.getFriendProfilePath(id)}${giftSuffix}`}
                      name={display_name || `${firstname} ${lastname}`.trim()}
                      image={image}
                      isPerson
                      onClick={(e) => { updateUserDetails(firstname, lastname, email, id, image, type, display_name); }}
                    />
                  ))}
                  <ProfileDrawerProfileButton
                    Icon={AddIcon}
                    link="#"
                    name={headerText?.dropDown?.requestAccess || 'Request access'}
                    onClick={revealAccessRequestModal}
                  />
                </div>
              </div>
            </div>
            <div className={styles.profileBarLinksContainer}>
              {links.map(({ name, link, onClick }, idx) => (
                <Link to={link} key={idx} onClick={onClick} className={styles.profileBarLink}>{name}</Link>
              ))}
            </div>
          </div>
        </div>
      </Drawer>
      <UploadModal isVisible={uploadModalIsVisible} onHide={hideUploadModal} />
      <PhotoUploadModal
        open={openPhotoUploadModal}
        onClose={hidePhotoUploadModal}
        userData={{
          subscription: userDetails?.isSubscription || null,
          totalContentUploaded: userDetails?.totalContentUploaded || 0
        }}
      />
      {/* Upload-blocker is now rendered globally in app.jsx (works in both UIs). */}
      {trailModalVisible && <TrailpopUp onHide={() => setTrailPopUpModalVisible(false)} />}
      {
        showProgressBox ? <ProgressBox /> : null
      }
      {/* DownloadProgressBox is now integrated into UploadPanel */}
      {/* {
        showDownloadBox ? <DownloadProgressBox /> : null
      } */}
      <ShareScreen
        actionButtonLoadingText={`${commonText?.requestingAccess || 'Requesting Access'}...`}
        actionButtonText={commonText?.requestAccess || 'Request Access'}
        apiEndpoint={endpoints.searchCreatorByEmail}
        errorText={commonText?.somethingWentWrong || 'Oops! Something went wrong'}
        inputPlaceholder={commonText?.searchEmail || 'Search by email'}
        isVisible={accessRequestModalIsVisible}
        multipleSelect
        notes={commonText?.enterEmail || 'Enter an email to search'}
        noUsersFoundText={commonText?.noUser || 'No users found with this email'}
        onContinue={requestProfileAccess}
        onHide={hideAccessRequestModal}
        successText={commonText?.requestSent || 'Request sent'}
        title={commonText?.requestAccessTitle || 'Request Access to View'}
        isViewerInvite
        darkTheme={isDarkAccessPage}
      />
      <ShareScreen
        actionButtonLoadingText={`${commonText?.grantingAccess || 'Granting Access'}...`}
        actionButtonText={commonText?.add || 'Add'}
        apiEndpoint={endpoints.searchUserToInvite}
        errorText={commonText?.somethingWentWrong || 'Oops! Something went wrong'}
        inputPlaceholder={commonText?.searchEmail || 'Search by email'}
        isVisible={accessGrantModalIsVisible}
        multipleSelect
        notes={commonText?.enterEmail || 'Enter an email to search'}
        noUsersFoundText={commonText?.noUser || 'No users found with this email'}
        onContinue={grantProfileAccess}
        onHide={hideAccessGrantModal}
        successText={commonText?.accessGranted || 'Access Granted'}
        title={commonText?.grantAccessTitle || 'Grant Access'}
        grandAccess
        isViewerInvite
        darkTheme={isDarkAccessPage}
      />
      <ShareScreen
        actionButtonLoadingText={`${commonText?.invitingFriend || 'Inviting friend'}...`}
        actionButtonText={commonText?.invite || 'Invite'}
        apiEndpoint={endpoints.searchUserInSystem}
        errorText={errorMsg || commonText?.somethingWentWrong || 'Oops! Something went wrong'}
        inputPlaceholder={commonText?.enterEmailOnly || 'Enter email'}
        isVisible={referFriendModalIsVisible}
        multipleSelect
        notes={commonText?.enterFriendEmail || 'Enter your friends email address'}
        noUsersFoundText={commonText?.noUser || 'No users found with this email'}
        onContinue={sendInvitation}
        onHide={hideInviteFriendModal}
        successText={commonText?.invitedFriend || 'Invited Friend'}
        title={commonText?.referFriendTitle || 'Refer A Friend'}
        subTitle={commonText?.referFriendSubTitle || 'You get two free months on a paid plan and they get a free month'}
        grandAccess
        isViewerInvite
      />
      <CreateGroup />
      {/* {
        isStorageFull && (
          <InfoModal
            isVisible={isStorageFull}
            title={processingInfo ? 'Video being processed' : contentDashboard?.timeToUpgradePlan || 'Time To Upgrade Plans'}
            onHide={() => { setStorageFull(false); }}
            continueButton={processingInfo ? 'Goto Contents' : contentDashboard?.upgrade || 'Upgrade'}
            content={processingInfo ? 'Your video will show up in your contents after it is finished processing.' : contentDashboard?.storageExceeded || 'You have exceeded your storage or viewer limit. Click upgrade to see available options!'}
            pathName={processingInfo ? Pathname.yourVideos : Pathname.plans}
            processingInfo
          />
        )
      } */}
      {mangerFunctionData === true
        && <MessageComponent setmangerFunctionData={setmangerFunctionData} message={messaged || 'Invalid'} />}
      <VideoUploadModal
        open={openNewUploadModal}
        onClose={() => setOpenNewUploadModal(false)}
        userDataProp={{
          subscription: userDetails?.isSubscription || null,
          totalContentUploaded: userDetails?.totalContentUploaded || 0
        }}
      />
      {/* Alert banner — same rect as the floating pill; flips in over it and
          flips out on Dismiss to reveal the pill (whose amber icon re-opens it). */}
      {slimPill && (
        <div className={cn(styles.pillBannerAnchor, { [styles.railAligned]: hasFloatingSidebar })} aria-hidden={!showAlertBanner}>
          <AnimatePresence initial={false}>
            {showAlertBanner && activeAlerts?.[0] && (
              <motion.div
                key="pill-alert-banner"
                className={styles.pillBannerCard}
                initial={{ rotateX: -90, opacity: 0 }}
                animate={{ rotateX: 0, opacity: 1 }}
                exit={{ rotateX: 90, opacity: 0 }}
                transition={{ duration: 0.44, ease: [0.22, 1, 0.36, 1] }}
                style={{ transformPerspective: 1400 }}
              >
                <span className={styles.pillBannerIcon}>
                  <AnimatedAlertTriangle size={22} animate />
                </span>
                <span className={styles.pillBannerText}>
                  <span className={styles.pillBannerTitle}>
                    {activeAlerts[0].title}
                    {activeAlerts.length > 1 ? ` (+${activeAlerts.length - 1})` : ''}
                  </span>
                  <span className={styles.pillBannerMsg}>{activeAlerts[0].message}</span>
                </span>
                <button
                  type="button"
                  className={styles.pillBannerDismiss}
                  onClick={() => alertStore.dismissBanner()}
                >
                  Dismiss
                </button>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      )}
    </>
  );
};
